import { DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { EMPTY_VALUE, FieldSchema } from "../../../Schema";

export const controlledEquipmentStatusOptions = [
  { value: "CALIBRATED", label: "Calibrated" },
  { value: "NA", label: "NA" },
  { value: "NOT_CALIBRATED", label: "Not calibrated" },
];

export const controlledEquipmentStatus: FieldSchema = {
  name: "controlledEquipmentStatus",
  grid: {
    displayed: true,
    order: 43,
  },
  data: {
    variant: DataVariants.ENUM,
    options: controlledEquipmentStatusOptions,
    assignedValue: {
      getter: ({ qualificationStatus }) => {
        if (!!qualificationStatus && qualificationStatus !== "NA") return "NA";
        return undefined;
      },
      fields: ["qualificationStatus"],
    },
  },
  display: {
    displayed: true,
  },
  validation: {
    required: true,
    // An equipment is either qualified or calibration-controlled, not both. Only one of
    // the two may carry a real value; the other has to be "NA".
    custom: {
      getter: ({ qualificationStatus, controlledEquipmentStatus }) =>
        qualificationStatus && controlledEquipmentStatus &&
        qualificationStatus !== "NA" && controlledEquipmentStatus !== "NA" ?
          "Conflicting values between Qualification Status and Controlled Equipment Status" :
          EMPTY_VALUE,
      fields: ["qualificationStatus", "controlledEquipmentStatus"],
    },
  },
  form: {
    label: "Calibration status",
    type: InputTypes.SELECT,
    disabled: {
      getter: ({ qualificationStatus }) =>
        !!qualificationStatus && qualificationStatus !== "NA",
      fields: ["qualificationStatus"],
    },
  },
};
